module.exports = __webpack_public_path__ + "img/record.599e7fcb.svg";